import  React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some';

import { TabMenu } from 'primereact/tabmenu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { SplitButton } from 'primereact/splitbutton';

import EditHtml from '@components/EditHtml';
import JustificationModal from '@components/JustificationModal';

import { validatePermissionAction } from '@actions/sessionPermission';

import { LANGUAGE_DEFAULT, AuthorizedStatus } from '@constants/general';
import { SET_VALUES_DIGITAL_FORM } from '@constants/actionType';
import catalogPermissionsId from '@constants/catalogPermissionsId'

import { createCheckboxCm } from '@utils/digitalForm'

import store from '@store';

import './style.scss'

class DigitalFormGeneral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      activeTabIndex: 0,
      removeRenderTabs: false,
      btnSubmitLoading: false,
      versionSelected: '',
      errors: {},
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      canEditHtml: false,
      canAddDeleteOptionsHtml: false,
      canSaveBtn: false
    };

    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
    ]
  }

  async componentDidMount () {
    this.initialState()
    this.validateOptionsSlit()
    this.validateCanEdit()
    this.validateCanAddRemoveOptions()
    this.validateBtnSaveActions()
    this.setState({loadingPage: false})
  }

  initialState = () => {
    const { _general, keysLenguages, _versiones, _version } = this.props
  
    if (_general) {
      const findVersion = _versiones.find(item => item.version === _version)
      this.setState({
        versionSelected: findVersion,
        ..._general
      })
      if (!_general[LANGUAGE_DEFAULT].plantilla) keysLenguages.map((item) => this.setState((prevState) => ({ [item]: { ...prevState[item], plantilla: "" } })));
    } else {
      keysLenguages.map((item) => this.setState({ [item]: { ...this.initialValuesForm } }));
    }
  }
  
  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, _estatus } = this.props
    if (isEdit) {
      // @Editar doc
      if (!(_estatus === AuthorizedStatus.STATUS_AUTHORIZED || _estatus === AuthorizedStatus.STATUS_INACTIVE)) {

          if (validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_FD)) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
            this.actions.unshift({
              label: this.props.t('Autorizar'),
              icon: 'pi pi-check-circle',
              command: () => {
                this.onSubmit((justification) =>  this.props.authorize(justification))
              }
            })
          } else {
              this.actions.unshift({
                label: this.props.t('Enviar a autorizar'),
                icon: 'pi pi-envelope',
                command: () => {
                  this.onSubmit((justification) =>  this.props.sendAuthorize(justification))
  
                }
              })
          }
      }
    }
  }

  validateCanEdit = () => {
    const { _estatus, validatePermissionAction } = this.props

    if (_estatus === AuthorizedStatus.STATUS_INACTIVE) {
      if (validatePermissionAction(catalogPermissionsId.TRADUCCION_INACTIVOS_FD)) {
        return this.setState({canEditHtml: true})
      }
      return true
    } else if (
      validatePermissionAction(catalogPermissionsId.EDICION_DE_ANEXO_FD) ||
      validatePermissionAction(catalogPermissionsId.TRADUCCION_DE_TEXTOS_FD)
    ) {
      return this.setState({canEditHtml: true})
    }
  }

  validateBtnSaveActions = () => {
    const { _estatus, validatePermissionAction } = this.props
    // Si es Inactivo
      // Si tiene permiso de traducir inactivo 
        // Se muestra Guardar
        // No se muestra
    // Autorizado
      //Si tiene permiso de adicion anexos, traducir textos, 
        // Si muestra Guardar
        // No muestra
    // Edicion, Pendiente
      //Si tiene permiso de adicion anexos, traducir textos, 
        // Si muestra Guardar
        // No muestra
      // Si tiene edicion o traducir y permiso de autorizar rechazar
        // Si muestra guardar y el split autorizar rechazar
      // Si no tiene edicion o traducir y permiso de autorizar rechazar
        // Directamente autorizar y en el split rechazar
    let showBtn = false 
      
    if (_estatus === AuthorizedStatus.STATUS_INACTIVE) {
      if (validatePermissionAction(catalogPermissionsId.TRADUCCION_INACTIVOS_FD)) {
        showBtn = true
      }
    } else if (_estatus === AuthorizedStatus.STATUS_AUTHORIZED) {
      if (validatePermissionAction(catalogPermissionsId.EDICION_DE_ANEXO_FD) || validatePermissionAction(catalogPermissionsId.TRADUCCION_DE_TEXTOS_FD)) {
        showBtn = true
      }
    } else if (validatePermissionAction(catalogPermissionsId.EDICION_DE_ANEXO_FD) || validatePermissionAction(catalogPermissionsId.TRADUCCION_DE_TEXTOS_FD) || validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_FD)){
        showBtn = true
    }

    this.setState({canSaveBtn: showBtn})
  }

  validateCanAddRemoveOptions = () => {
    const { validatePermissionAction, _estatus } = this.props
    const canAddDeleteOptions = _estatus === AuthorizedStatus.STATUS_INACTIVE 
      ? false
      : validatePermissionAction(catalogPermissionsId.EDICION_DE_ANEXO_FD)
    this.setState({ canAddDeleteOptionsHtml: canAddDeleteOptions })
  }

  onChangeHtml = (valueHtml, language) =>  {
    this.setState((prevState) => ({
      [language]: { ...prevState[language], plantilla: valueHtml.outerHTML },
    }));
  }

  onChangeSimple = ({ target }) => {
    if (target.name === 'nombre' && target.value) target.value = target.value.toUpperCase()
    this.setState({[target.name]: target.value}, () => this.validateFieldsOnchange(target.name, target.value));
  };


  onChangeTab = (e) => {
    this.setState({removeRenderTabs: true})
    setTimeout(() => {
      this.setState({removeRenderTabs: false, activeTabIndex: e.index})
    }, 50);
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }


  onSubmit = async (onAction) => {
    const { t } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    console.log('Submit')
    await this.setValuesToStateGlobal();
    return this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => onAction(justification),
      },
    });
  }

  validateFields = async () => {
    const { t } = this.props
    const { descripcion } = this.state
    let errors = {}
    // if (!descripcion) errors = {...errors, [`descripcion`]: `${t('Descripcion')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }

  setValuesToStateGlobal = async () => {
    const { keysLenguages } = this.props;
    const { descripcion, nombre } = this.state;

    const getValues = keysLenguages.reduce((accum, item) => {
      let values = this.state[item]
      accum[item] = values;
      return accum;
    }, {});

    console.log('getValues', getValues)

    await store.dispatch({
      type: SET_VALUES_DIGITAL_FORM,
      payload: {
        general: {
          nombre,
          descripcion,
          ...getValues
        },
      },
    });
    return true
  };

  onReplicToOthersTemplates = ({ e, type, options }) => {
    const { keysLenguages } = this.props
    const { activeTabIndex } = this.state
    if (type === 'select-values') {
      keysLenguages.map(key => {
        if (key !== keysLenguages[activeTabIndex]) {
          const temp = document.createElement('div');
          temp.innerHTML= this.state[key].plantilla;
          const getELements = temp.getElementsByTagName("select");
          for (let i = 0; i < getELements.length; i++) {
            if (getELements[i].name === e.target.name) {
              for (let index = 0; index < getELements[i].options.length; index += 1) {
                getELements[i].options[index].value = options.optionsSelect[index].value
              }
              this.onChangeHtml(temp.firstChild, key)
            }
          }
        }
      })
    } else if (type === 'select-add') {
      keysLenguages.map(key => {
        if (key !== keysLenguages[activeTabIndex]) {
          const temp = document.createElement('div');
          temp.innerHTML= this.state[key].plantilla;
          const getELements = temp.getElementsByTagName("select");
          for (let i = 0; i < getELements.length; i++) {
            if (getELements[i].name === e.target.name) {
              const option = document.createElement( 'option' );
              option.value = options.newValue;
              option.text = options.newText;
    
              getELements[i].add( option );
              this.onChangeHtml(temp.firstChild, key)
            }
          }
        }
      })
    } else if (type === 'select-delete') {
      keysLenguages.map(key => {
        if (key !== keysLenguages[activeTabIndex]) {
          const temp = document.createElement('div');
          temp.innerHTML= this.state[key].plantilla;
          const getELements = temp.getElementsByTagName("select");
          for (let i = 0; i < getELements.length; i++) {
            if (getELements[i].name === e.target.name) {
              const allOptions =  getELements[i].getElementsByTagName('OPTION');
              for (let index =  getELements[i].length - 1; index >= 0; index--){
                const isExist = options.deleteOptionsSelect.find(item => item.value ===  getELements[i].options[index].value)

                if (!isExist) {
                  getELements[i].removeChild( allOptions[index]);
                }
              }
              this.onChangeHtml(temp.firstChild, key)
            }
          }
        }
      })
    } else if (type === 'checkboxCm-values') {
      keysLenguages.map(key => {
        if (key !== keysLenguages[activeTabIndex]) {
          const temp = document.createElement('div');
          temp.innerHTML= this.state[key].plantilla;
          const getNameInput = e.target.getAttribute('data-name')
          const getParentId = e.target.getAttribute('data-parentid')
          const getParentElement = temp.querySelector(`#${getParentId}`)
          const getInputs = getParentElement.querySelectorAll(`input[name='${getNameInput}']`)

          for (let i = 0; i < getInputs.length; i++) {
            getInputs[i].value = options.optionsCheck[i].value
          }
          this.onChangeHtml(temp.firstChild, key)
        }
      })
    } else if (type === 'checkboxCm-delete') {
      keysLenguages.map(key => {
        if (key !== keysLenguages[activeTabIndex]) {
          const temp = document.createElement('div');
          temp.innerHTML= this.state[key].plantilla;
          const getNameInput = e.target.getAttribute('data-name')
          const getParentId = e.target.getAttribute('data-parentid')
          const getParentElement = temp.querySelector(`#${getParentId}`)
          const getInputs = getParentElement.querySelectorAll(`input[name='${getNameInput}']`)
          for (let i =  getInputs.length - 1; i >= 0; i--){
            const isExist = options.deleteOptionsCheck.find(item => item.value ===  getInputs[i].value)
            if (!isExist) {
              const getParent = getInputs[i].parentElement.parentElement
              getParent.remove()
            }
          }
          this.onChangeHtml(temp.firstChild, key)
        }
      })
    } else if (type === 'checkboxCm-add') {
      keysLenguages.map(key => {
        if (key !== keysLenguages[activeTabIndex]) {
          const temp = document.createElement('div');
          temp.innerHTML= this.state[key].plantilla;
          const getNameInput = e.target.getAttribute('data-name')
          const getParentId = e.target.getAttribute('data-parentid')
          const div = document.createElement('div');
          div.innerHTML = createCheckboxCm({newValue: options.newValue, newText: options.newText, nameInput: getNameInput, parentId: getParentId})
          const getParentElement = temp.querySelector(`#${getParentId}`)
          getParentElement.append(div.firstElementChild)
          this.onChangeHtml(temp.firstChild, key)
        }
      })
    }
  }

  onChangeVersion = ({target}) => {
    const { t, changeVersion } = this.props
    confirmDialog({
      message: t('Estas a punto de cambiar de versión, los cambios realizados se perderan. ¿Estas seguro?'),
      header: t('Confirmación'),
      icon: 'pi pi-check-circle',
      acceptLabel: t('Si, continuar'),
      accept: () => changeVersion(target.value.id),
      onHide: () => {}
    });
  }

  render() {

    const { t, history, itemsTabsLenguages, keysLenguages, _idFormulario, _idAnexo, _estatus, _versiones, success, authorize } = this.props
    const { loadingPage, activeTabIndex, removeRenderTabs, errors, btnSubmitLoading, showModalJustification, versionSelected, canEditHtml, canAddDeleteOptionsHtml, canSaveBtn  } = this.state

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];

      return (
        <>
          <div className="p-col-12 p-p-5 content-edit-html">
            <EditHtml
              onChange={(e) => this.onChangeHtml(e, prefixLenguage)}
              htmlValue={this.state[prefixLenguage].plantilla}
              isMicrositio
              replicToOthersTemplates={this.onReplicToOthersTemplates}
              isEdit={canEditHtml}
              isAddRemoveElements={canAddDeleteOptionsHtml}
            />
          </div>
        </>
      );
    }

    
    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderSaveBtn = () => {
      const isEditAndPenddingStatus = _estatus === AuthorizedStatus.STATUS_EDITION ||  _estatus === AuthorizedStatus.STATUS_PENDING
      // Status Edicion, pendiente ----> Si solo tiene rechazar y autorizar presentar automaticamente autorizar

      if (isEditAndPenddingStatus && !canEditHtml ) {
        return (
          <SplitButton label={t('Autorizar')} icon="pi pi-save" onClick={() => this.onSubmit((justification) => authorize(justification))} model={this.actions}/>
        )
      }
      return (
        <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit((justification) => success(justification))} model={this.actions}/>
      )
    }

    if (loadingPage) return true

    return (
      <div className="p-col-12 p-mt-2">
        <div className="card">
          <div className="p-grid">
            <div className='p-col-8'/>
            <div className="p-col-12 p-lg-4 border-versions p-fluid ">
              <label className="p-mb-3 p-text-bold">{t('Versiones')}:</label>
              <Dropdown
                name="filterSelected"
                value={versionSelected}
                options={_versiones}
                onChange={this.onChangeVersion}
                optionLabel="version"
                placeholder=""
                // style={{ width: '40%' }}
              />
            </div>
            <br></br>
            <div className="p-col-4 p-lg-4 p-field p-mt-4">
              <div className='p-mr-4 border-rigth'>
                <label className="p-text-bold">
                  {t('ID')}
                </label>
                <p>{_idFormulario}</p>
              </div>
            </div>
            <div className="p-col-4 p-lg-4 p-field p-mt-4">
              <div className=''>
                <label className="p-text-bold">
                  {t('ID Anexo')}
                </label>
                <p>{_idAnexo}</p>
              </div>
            </div>
            <div className="p-col-4 p-lg-4 p-field p-mt-4">
              <div className='p-pl-5 border-left'>
                <label className="p-text-bold">
                  {t('Estatus')}
                </label>
                <p>{_estatus}</p>
              </div>
            </div>
            <div className="p-col-12 p-lg-12 p-field">
              <label htmlFor="title" className="p-text-bold">
                {t('Nombre')}
              </label>
              <p>{this.state.nombre}</p>
              {/* <InputText
                name={`nombre`}
                type="text"
                value={this.state.nombre}
                onChange={this.onChangeSimple}
                keyfilter="alpha"
                className={classNames({
                  'p-invalid': isFormFieldValid(`nombre`),
                })}
                disabled
              />
              {getFormErrorMessage(`nombre`)} */}
            </div>
            <div className="p-col-12 p-field  p-fluid ">
              <label htmlFor="title" className="p-text-bold">
                {t('Nombre Archivo')}
              </label>
              <InputText
                name={`archivo`}
                type="text"
                value={this.state.archivo}
                onChange={this.onChangeSimple}
                className={classNames({
                  'p-invalid': isFormFieldValid(`descripcion`),
                })}
                disabled
              />
              {getFormErrorMessage(`descripcion`)}
            </div>
            <div className='p-col-12'>
              <p>
                {t('Para poder modificar las propiedades de un dropdown/input da click derecho sobre el elemento a modificar.')}
                <Tooltip target=".custom-tooltip-btn"  autoHide={false}>
                    <img alt="logo" src="/assets/img/help-content-editable.PNG" data-pr-tooltip="Token_contract" height="297px" width="280px"/>
                </Tooltip>
                <Button className="custom-tooltip-btn p-button-text p-p-0" type="button" icon="pi pi-info-circle" />

              </p>

            </div>
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={this.onChangeTab}
                />
              )}
            </div>

            {!removeRenderTabs && renderByTabLenguage()}

            <div className="p-col-12 footer-btn">
              <div className="p-d-flex p-jc-between p-mt-4">
                <Button
                  label={t('Cancelar')}
                  type="button"
                  className="p-button-secondary"
                  onClick={() => history.push('/emails')}
                />
                { canSaveBtn && renderSaveBtn()}
                {/* <Button
                  label={t('Continuar')}
                  onClick={() => this.onSubmit()}
                  className="p-button-primary"
                  loading={btnSubmitLoading}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _general: state.digitalForm.general,
  _idFormulario: state.digitalForm.idFormulario,
  _idAnexo: state.digitalForm.idAnexo,
  _version: state.digitalForm.version,
  _estatus: state.digitalForm.estatus,
  _versiones: state.digitalForm.versiones,

});

const mapDispatchToProps = {
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(DigitalFormGeneral);
